var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanners({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.83268V14.166C15 14.6827 14.9833 15.141 14.925 15.5493C14.6833 17.741 13.65 18.3327 10.8333 18.3327H9.16667C6.35 18.3327 5.31667 17.741 5.075 15.5493C5.01667 15.141 5 14.6827 5 14.166V5.83268C5 5.31602 5.01667 4.85768 5.075 4.44935C5.31667 2.25768 6.35 1.66602 9.16667 1.66602H10.8333C13.65 1.66602 14.6833 2.25768 14.925 4.44935C14.9833 4.85768 15 5.31602 15 5.83268Z",
    stroke: "#A0ACB9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 14.1664C4.99984 14.6831 5.0165 15.1414 5.07484 15.5497C4.95817 15.5581 4.84984 15.5581 4.72484 15.5581H4.4415C2.22484 15.5581 1.6665 14.9997 1.6665 12.7747V7.22474C1.6665 4.99974 2.22484 4.44141 4.4415 4.44141H4.72484C4.84984 4.44141 4.95817 4.44141 5.07484 4.44974C5.0165 4.85807 4.99984 5.31641 4.99984 5.83307V14.1664Z",
    stroke: "#A0ACB9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3331 7.22474V12.7747C18.3331 14.9997 17.7748 15.5581 15.5581 15.5581H15.2748C15.1498 15.5581 15.0415 15.5581 14.9248 15.5497C14.9831 15.1414 14.9998 14.6831 14.9998 14.1664V5.83307C14.9998 5.31641 14.9831 4.85807 14.9248 4.44974C15.0415 4.44141 15.1498 4.44141 15.2748 4.44141H15.5581C17.7748 4.44141 18.3331 4.99974 18.3331 7.22474Z",
    stroke: "#A0ACB9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanners);
export default __webpack_public_path__ + "static/media/banners.388813bda0ba49a5c7761ecc5eaed78f.svg";
export { ForwardRef as ReactComponent };